const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    attribute_id: {
      type: 'string',
      title: 'صفت',
    },
    details: {
      type: 'string',
      title: 'توضیحات',

    },
  },
});

export default schema;
